import { baseApi } from "@/shared/api";
import type { AuditListResponse } from "@/shared/types/audit";

export const taskAuditApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaskAudit: builder.query<AuditListResponse, number>({
      query: (taskId) => ({
        url: `/api/audit/?target_type=task&target_id=${taskId}&page_size=50`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: (_result, _error, taskId) => [
        { type: "AuditEntries", id: `task-${taskId}` },
      ],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetTaskAuditQuery } = taskAuditApi;
